import { ICampaignDetailsState } from "../../app/store/campaign/details/types";
import CampaignEanexSubmit from "../../entities/campaigns/eanex/CampaignEanexSubmit";


export default class CampaignEanexSubmitObjectFactory {

  static create(campaignDetailsState: ICampaignDetailsState, hash: string) {
    return new CampaignEanexSubmit(campaignDetailsState, hash);
  }

}
